export class FormatNumber {
  static formatarNumero(numero: number) {
    if (Math.abs(numero) < 0.0001) return '0'

    if (numero) return numero.toLocaleString('pt-BR')

    return null
  }
}
